import styled from "styled-components";

const PanelContentContainer = styled.div`
    padding: 1em;
`;

export default PanelContentContainer;
